import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  profilType : string ;


  constructor() { }

public saveToken(token : string){
  localStorage.setItem('profil', token);
}

public logOut(): void {
  localStorage.removeItem('profil');
  localStorage.removeItem('menuItem');
}

  /**
   * get user token
   */
   public loadToken(): void {
    this.profilType = localStorage.getItem('profil');
  }

   /**
   * verify if user is logged in 
   * @returns 
   */
    public isLoggedIn(): boolean {
      this.loadToken()
      if (this.profilType != null && this.profilType !== '') {
       return true;
      } else {
        this.logOut();
        return false;
      }
      return;
    }
}
